import React from 'react';
import PropTypes from 'prop-types';

import Beneficiaries from 'components/beneficiaries/Beneficiaries';
import BeneficiaryBriefDetailsModal from 'components/beneficiaries/BeneficiaryBriefDetailsModal';
import BeneficiaryBriefDetailsModal2 from 'components/beneficiaries/BeneficiaryPreviewDetailsModal';
import BeneficiariesListCard from 'components/beneficiaries/BeneficiariesListCard';

export default function CustomerBeneficiariesTab({ customerId }) {
  return (
    <>
      <Beneficiaries filterByCustomer={true} customerId={customerId} />
      <BeneficiariesListCard filterByCustomer={true} customerId={customerId} />
      <BeneficiaryBriefDetailsModal2 />
    </>
  );
}

Beneficiaries.propTypes = {
  customerId: PropTypes.string.isRequired,
};
